import {parseISO, isWithinInterval, isSameDay, startOfDay, endOfDay} from 'date-fns';

/**
 * Checks if a date falls within the range of an event (inclusive of start and end dates)
 * For multi-day events, this will return true for any date between start and end
 * For all-day events (start === end), checks if the target date is the same day
 * @param eventStart - The start date of the event
 * @param eventEnd - The end date of the event
 * @param targetDate - The date to check
 * @returns True if the target date falls within the event range, false otherwise
 */
export function isDateInEventRange(
  eventStart: string | Date,
  eventEnd: string | Date,
  targetDate: string | Date
) {
  const parsedEventStart = typeof eventStart === 'string' ? parseISO(eventStart) : eventStart;
  const parsedEventEnd = typeof eventEnd === 'string' ? parseISO(eventEnd) : eventEnd;
  const parsedTargetDate = typeof targetDate === 'string' ? parseISO(targetDate) : targetDate;

  // All-day event: start and end are the same day
  if (isSameDay(parsedEventStart, parsedEventEnd)) {
    return isSameDay(parsedEventStart, parsedTargetDate);
  }

  // Multi-day event: check if targetDate is within the event interval
  return isWithinInterval(parsedTargetDate, {
    start: startOfDay(parsedEventStart),
    end: endOfDay(parsedEventEnd),
  });
}
